export enum SuggestionsKey {
  ARC_DISPLAY_NAME = 'arc_display_name',
  ARC_DISPLAY_TYPE = 'arc_display_type',
  LOCATION = 'arc_home_location_identity',
  // FIXME this is not an arc_ atribute but we need to make it to be
  DROPBOX_PATH = 'dropbox_path',
}
